import React from 'react';
import FormButton from '@ui/button/FormButton';
import { Integration } from '@app/model/integration-settings/Integration';
import { formatDayTime, RECORDS_WORD } from '../IntegrationSettings.utilities';

// The last line of an Availability or Reservations card: the last run, the next run, the buttons and the log link.
const IntegrationCardFooter: React.FunctionComponent<{
	integration: Integration,
	buttons: React.ReactNode,
	onOpenLog: () => void,
}> = ({ integration, buttons, onOpenLog }) => {
	const records = integration.lastRunRecords === null ? '' : ` · ${integration.lastRunRecords} ${RECORDS_WORD[integration.type]}`;
	const cancellations = integration.lastRunCancellations === null ? '' : ` · ${integration.lastRunCancellations} cancellations`;
	return <div className="mt-6 flex flex-col gap-4 border-t border-gray-200 pt-4 sm:flex-row sm:items-center sm:justify-between">
		<p className="text-sm text-gray-500">
			{integration.lastRunAt === null
				? <>No run yet</>
				: <>Last run <span className="font-medium text-gray-900">{formatDayTime(integration.lastRunAt)}</span>{records}{cancellations}</>}
			{integration.enabled && integration.nextRunAt !== null &&
				<> · Next run <span className="font-medium text-gray-900">{formatDayTime(integration.nextRunAt)}</span></>}
		</p>
		<div className="flex flex-wrap items-center gap-3">
			{buttons}
			{integration.status !== 'NOT_SET_UP' && <FormButton state="text" isLink onClick={onOpenLog}>View log →</FormButton>}
		</div>
	</div>;
};

export default IntegrationCardFooter;
